import Application from './application'
import Pages from './pages'
import OrdersCart from './orders-cart'

export default {
  Application,
  Pages,
  OrdersCart
}
